const Header = () => {
	return (
		<header className="relative z-10">
			<picture>
				<source media="(min-width: 768px)" srcSet={"/images/hero-destop.jpg"} />
				<img
					src={"/images/hero-mobile.jpg"}
					className=" block w-full"
					alt="wilintuhawaii Men's Care und IRONMAN European Series 2026"
				/>
			</picture>

			<img
				src={"/images/heroFlower.png"}
				alt="Blume als Symbol für die Einfachheit der Teilnahme"
				className="hidden sm:block absolute left-[5%] bottom-[-8%] w-[21.5%] "
			/>
		</header>
	)
}

export default Header
